/**
 * Two independent custom elements (same behavior, separate registry entries).
 * Used by sections/main-collection-product-grid-lock.liquid
 *
 * data-expires on the custom element should be a Unix timestamp in milliseconds
 * (Liquid: lock_unlock_ts | times: 1000  or  lock_sale_end_ts | times: 1000).
 * Falls back to parsing the <time datetime="..."> attribute for legacy support.
 */
(function () {
  if (!window.customElements) return;

  var HOUR_MS = 3600000;
  var MIN_MS = 60000;
  var SEC_MS = 1000;
  var RELOAD_COOLDOWN_MS = 30000;

  function pad(n) {
    n = parseInt(n, 10);
    return n < 10 ? '0' + n : '' + n;
  }

  function safeReload(key) {
    if (window.Shopify && window.Shopify.designMode) return;
    try {
      var stored = parseInt(sessionStorage.getItem(key) || '0', 10);
      var now = Date.now();
      if (now - stored < RELOAD_COOLDOWN_MS) return;
      sessionStorage.setItem(key, String(now));
    } catch (e) {}
    setTimeout(function () {
      window.location.reload();
    }, 600);
  }

  /**
   * Parse a raw value into a Unix-ms timestamp.
   * Accepts:
   *   - A plain integer/float string that looks like a Unix-ms timestamp (> 1e12)
   *   - A plain integer/float string that looks like a Unix-second timestamp (10 digits, < 1e12)
   *   - An ISO 8601 date string (legacy fallback)
   */
  function parseDatetime(raw) {
    if (!raw) return NaN;

    var n = parseFloat(raw);
    if (!isNaN(n)) {
      // Unix milliseconds (13 digits)
      if (n > 1e12) return n;
      // Unix seconds (10 digits) — shouldn't happen but handle gracefully
      if (n > 1e9) return n * 1000;
    }

    // ISO date string fallback
    var ts = Date.parse(raw);
    if (!isNaN(ts)) return ts;

    var cleaned = String(raw).replace(/\.\D[^+\-Z]*/g, '');
    return Date.parse(cleaned);
  }

  function createCountdownElementClass() {
    return class extends HTMLElement {
      connectedCallback() {
        if (!this._visBound) {
          this._visBound = true;
          var self = this;
          this._visHandler = function () {
            if (document.visibilityState === 'visible') self._tick();
          };
        }
        this._teardown();
        queueMicrotask(
          function () {
            this._setup();
          }.bind(this)
        );
      }

      disconnectedCallback() {
        this._teardown();
        this._visBound = false;
        this._visHandler = null;
      }

      _teardown() {
        if (this._interval) {
          clearInterval(this._interval);
          this._interval = null;
        }
        if (this._visHandler) {
          document.removeEventListener('visibilitychange', this._visHandler);
        }
      }

      _setup() {
        if (!this.isConnected) return;

        this._teardown();

        this.timeEl = this.querySelector('time');
        this.hoursEl = this.querySelector('.js-cd-h, [data-hours]');
        this.minutesEl = this.querySelector('.js-cd-m, [data-minutes]');
        this.secondsEl = this.querySelector('.js-cd-s, [data-seconds]');

        if (!this.hoursEl && !this.minutesEl && !this.secondsEl) {
          this._retryChildBind();
          return;
        }

        // Prefer data-expires on the custom element (Unix ms from Liquid)
        var raw = this.getAttribute('data-expires') || '';
        if (!raw && this.timeEl) {
          raw = this.timeEl.getAttribute('datetime') || '';
        }

        this.datetime = raw;
        this.endDate = parseDatetime(raw);

        if (isNaN(this.endDate)) {
          this.renderZero();
          return;
        }

        if (this.endDate <= Date.now()) {
          this.renderZero();
          safeReload('__pi_lock_reload:' + this.datetime);
          return;
        }

        this._tick();
        var self = this;
        this._interval = setInterval(function () {
          if (!self.isConnected) {
            if (self._interval) {
              clearInterval(self._interval);
              self._interval = null;
            }
            return;
          }
          self._tick();
        }, 1000);
        document.addEventListener('visibilitychange', this._visHandler);
      }

      _retryChildBind() {
        var self = this;
        var tries = 0;
        (function tryAgain() {
          if (!self.isConnected) return;
          if (self.querySelector('.js-cd-h, [data-hours]')) {
            self._setup();
            return;
          }
          if (++tries < 6) {
            setTimeout(tryAgain, 50);
          }
        })();
      }

      _tick() {
        if (!this.isConnected) return;
        if (this.endDate == null || isNaN(this.endDate)) return;

        var diff = this.endDate - Date.now();
        if (diff <= 1000) {
          this._teardown();
          this.onComplete();
          return;
        }

        var hours = Math.floor(diff / HOUR_MS);
        diff -= hours * HOUR_MS;
        var minutes = Math.floor(diff / MIN_MS);
        diff -= minutes * MIN_MS;
        var seconds = Math.floor(diff / SEC_MS);

        if (this.hoursEl) this.hoursEl.textContent = pad(hours);
        if (this.minutesEl) this.minutesEl.textContent = pad(minutes);
        if (this.secondsEl) this.secondsEl.textContent = pad(seconds);
      }

      renderZero() {
        if (this.hoursEl) this.hoursEl.textContent = '00';
        if (this.minutesEl) this.minutesEl.textContent = '00';
        if (this.secondsEl) this.secondsEl.textContent = '00';
      }

      onComplete() {
        this.renderZero();
        safeReload('__pi_lock_reload:' + this.datetime);
      }
    };
  }

  if (!customElements.get('pi-unlock-timer')) {
    customElements.define('pi-unlock-timer', createCountdownElementClass());
  }
  if (!customElements.get('pi-sale-timer')) {
    customElements.define('pi-sale-timer', createCountdownElementClass());
  }
})();
